import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BeyondTheMap from "./sections/BeyondTheMap";
import AboutRestaurant from "./sections/AboutRestaurant";
import SanctuariesOfPeace from "./sections/SanctuariesOfPeace";
import WhyChooseAnExpertBroker from "./sections/WhyChooseAnExpertBroker";
import VociDalMare from "./sections/VociDalMare";
import RoundTheClockSupport from "./sections/RoundTheClockSupport";
import FooterInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BeyondTheMap />
      <AboutRestaurant />
      <SanctuariesOfPeace />
      <WhyChooseAnExpertBroker />
      <VociDalMare />
      <RoundTheClockSupport />
      <FooterInfo />
    </div>;
}